import React from "react";
import { Table } from "react-bootstrap";
import "./SimulationTable.css";

const ROW_HEADERS = [
  "Vitesse de vent",
  "Direction du vent",
  "Humidité du combustible",
  "Température",
];

const SimulationTable = ({ item }) => {
  if (item.fire.type !== "simulation") return null;

  const polygons = (item.polygons || [])
    .filter((poly) => poly.type !== "start")
    .sort((a, b) => Number(a.order) - Number(b.order));

  if (polygons.length === 0) return null;

  const getColLabel = (polygon, index) => {
    const order = Number(polygon.order);
    if (order === 0) return "Début";
    const dtMin = item.fire.dt_polygons;
    if (dtMin) {
      const totalMin = order * Number(dtMin);
      const h = Math.floor(totalMin / 60);
      const m = totalMin % 60;
      return m === 0 ? `+${h}h` : `+${h}h${m}`;
    }
    return index === 0 ? "Début" : `+${index}h`;
  };

  const getCellValue = (polygon, rowIndex) => {
    if (rowIndex === 0) {
      const v = polygon.wind_speed;
      return typeof v === "number" ? v.toFixed(2) : (v ?? "—");
    }
    if (rowIndex === 1) return polygon.wind_direction ?? "—";
    if (rowIndex === 2) return polygon.fuel_moisture ?? "—";
    if (rowIndex === 3) {
      const v = polygon.ambient_tempreture;
      return typeof v === "number" ? v.toFixed(2) : (v ?? "—");
    }
    return "—";
  };

  return (
    <div className="sim-table-compact">
      <Table bordered size="sm">
        <thead>
          <tr>
            <th></th>
            {polygons.map((poly, i) => (
              <th key={poly.order ?? i}>{getColLabel(poly, i)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROW_HEADERS.map((rowHeader, rowIndex) => (
            <tr key={rowIndex}>
              <td>{rowHeader}</td>
              {polygons.map((poly, i) => (
                <td key={poly.order ?? i}>{getCellValue(poly, rowIndex)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SimulationTable;
